import gsap from 'gsap';

let Global = {
  sessionId: null,
  gameTry: 0,
  delta: 0,
  shootCnt: 0,
  xPadd: 0,
  age: 0,
  goBackTo: null,
  isGameActive: false,
  scoreSubmitted: false,
  scoreTotal: 0,
  introShown: false,
  introActive: false,
  totalGoalsSaved: 0,
  timeTaken: 0,
  scaleFact: 1,
  canSwipe: false,
  soundEnabled: true,
  limitReached: false,
  userKey: null,
  jumpHeight: 'high',
  avatarName: null,
  gender: 'Male',
  userName: '',
  email: null,
  mobile: null,
  location: null,
  IGHandle: null,
  yob: null,
  cameraPanTime: 5 * 1,
  totalKicks: 15,
  kicksTriggerd: 0,
  BASE_URL: 'https://www.newsfeedsmartapp.com/CarlsbergPenalty/',
  URL_CREATE: 'https://www.newsfeedsmartapp.com/CarlsbergPenalty/create.php',
  URL_DATA: 'https://www.newsfeedsmartapp.com/CarlsbergPenalty/data.php',
  URL_LEADER: 'https://www.newsfeedsmartapp.com/CarlsbergPenalty/getLeader.php',
  URL_JERSEY: 'https://www.newsfeedsmartapp.com/CarlsbergPenalty/jersey.php',
  URL_VUPDATE:
    'https://www.newsfeedsmartapp.com/CarlsbergPenalty/valueUpdator.php',
  animateButton: function (btn, isHTML) {
    if (isHTML) {
      gsap.to(btn, {
        scale: 1, // The final scale (100%)
        duration: 0.35,
        ease: 'elastic.out(1, 0.3)',
        yoyo: true,
        repeat: 0,
        startAt: { scale: 0.9 }, // Start at 90%
      });
    } else {
      gsap.to(btn, {
        scaleX: btn.scaleX, // The target value
        scaleY: btn.scaleY,
        duration: 0.5, // GSAP uses seconds, not milliseconds
        ease: 'elastic.out(1, 0.3)',
        yoyo: true,
        startAt: {
          scaleX: btn.scaleX * 0.9,
          scaleY: btn.scaleY * 0.9,
        },
      });
    }
    //
  },
  assets: {
    cubemap: {},
    glbs: {
      head: {
        key: 'head',
        path: ['./models/head2.glb'],
        asset: null,
      },
      ball: {
        key: 'ball',
        path: ['./models/ball.glb'],
        asset: null,
      },
    },
    textures: {},
    sounds: {
      head: {
        key: 'head',
        path: ['./sounds/head.mp3'],
        asset: null,
      },
      click: {
        key: 'click',
        path: ['./sounds/click.mp3'],
        asset: null,
      },
    },
  },
};
export { Global };
